import { metaColors } from "./colors/meta";
import type { Theme } from "../semantic/types";
import { baseTypography } from "./typography/base";
import { baseSpacing } from "./spacing/base";
import { baseRadii } from "./radii/base";
import { baseShadows } from "./shadows/base";
import { baseBorders } from "./borders/base";
import { baseLayout } from "./layout/base";
import { spacing } from "../primitives/spacing";

export const metaTheme: Theme = {
  name: "meta",
  typography: baseTypography,
  spacing: baseSpacing,
  radii: baseRadii,
  shadows: baseShadows,
  borders: baseBorders,
  layout: baseLayout,
  colors: metaColors,

  text: {
    primary: metaColors.neutral[10],
    secondary: metaColors.neutral[40],
    tertiary: metaColors.neutral[60],
    disabled: metaColors.neutral[80],
    inverse: metaColors.neutral[100],
    interactive: metaColors.primary[50],
    placeholder: metaColors.neutral[50],
  },

  surface: {
    page: metaColors.neutral[95],
    card: metaColors.neutral[100],
    overlay: metaColors.overlay,
    sidebar: metaColors.primary[10],
    input: metaColors.neutral[100],
  },

  border: {
    default: metaColors.neutral[90],
    divider: metaColors.neutral[95],
    focus: metaColors.primary[50],
  },

  icon: {
    bottomPillActive: metaColors.primary[40],
    bottomPillInactive: metaColors.neutral[10],
  },

  input: {
    background: {
      default: metaColors.neutral[100],
      disabled: metaColors.neutral[95],
    },
    border: {
      default: metaColors.neutral[80],
      focus: metaColors.primary[50],
      error: metaColors.error[50],
    },
    padding: {
      sm: baseSpacing.sm,
      md: baseSpacing.md,
      lg: baseSpacing.lg,
    },
    radius: baseRadii.md,
  },

  select: {
    icon: {
      color: {
        default: metaColors.neutral[50],
        disabled: metaColors.neutral[80],
      },
    },
    item: {
      background: {
        default: metaColors.neutral[100],
        hover: metaColors.neutral[95],
        selected: metaColors.primary[10],
      },
      text: {
        default: metaColors.neutral[10],
        selected: metaColors.primary[60],
      },
    },
  },

  action: {
    primary: {
      default: metaColors.primary[50],
      hover: metaColors.primary[40],
      active: metaColors.primary[60],
      disabled: metaColors.primary[80],
      label: metaColors.neutral[100],
    },
    secondary: {
      default: metaColors.primary[95],
      hover: metaColors.primary[90],
      active: metaColors.primary[80],
      label: metaColors.primary[40],
    },
  },

  feedback: {
    info: metaColors.primary[50],
    success: metaColors.success[50],
    warning: metaColors.warning[50],
    error: metaColors.error[50],
  },

  control: {
    border: {
      default: metaColors.neutral[80],
      hover: metaColors.neutral[60],
      focus: metaColors.primary[50],
      active: metaColors.primary[60],
      disabled: metaColors.neutral[90],
      error: metaColors.error[50],
    },
    background: {
      default: metaColors.neutral[100],
      hover: metaColors.neutral[100],
      active: metaColors.neutral[95],
      disabled: metaColors.neutral[95],
    },
    text: {
      default: metaColors.neutral[10],
      placeholder: metaColors.neutral[50],
      disabled: metaColors.neutral[60],
      readonly: metaColors.neutral[40],
    },
    height: {
      sm: 32,
      md: 40,
      lg: 48,
    },
    padding: {
      x: {
        sm: baseSpacing.sm,
        md: baseSpacing.md,
        lg: baseSpacing.lg,
      },
    },
    radius: {
      sm: baseRadii.sm,
      md: baseRadii.md,
      lg: baseRadii.lg,
    },
  },
  textarea: {
    padding: {
      sm: baseSpacing.sm,
      md: spacing[5],
      lg: baseSpacing.lg,
    },
  },
};
